import * as React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import './swipeclockLoader.css';

export default function SwipeclockLoader({
  secondaryStrokeColor = '#37bdf8',
  strokeColor = '#262f3f',
  strokeWidth = '7',
  width = '128',
}) {
  return (
    <Box id="SwipeclockLoader">
      <svg viewBox="-2 0 104 100" width={width}>
        <polyline
          className="line1"
          fill="none"
          points="89,65 
            75,89
            25,89
            2,50
            25,11
            75,11"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <polyline
          className="line2"
          fill="none"
          points="83.2,25 
            98,50
            67,50"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <line
          className="line3"
          x1="27"
          y1="15"
          x2="64.7"
          y2="73"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        <line
          className="line4"
          x1="49"
          y1="50"
          x2="19"
          y2="50"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        <line
          className="line5"
          x1="33.2"
          y1="76"
          x2="66.8"
          y2="24"
          stroke={secondaryStrokeColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
      </svg>
    </Box>
  );
}

SwipeclockLoader.propTypes = {
  secondaryStrokeColor: PropTypes.string,
  strokeColor: PropTypes.string,
  strokeWidth: PropTypes.string,
  width: PropTypes.string,
};
